import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";

const PublicRoute = ({ children }) => {
  const { role } = useSelector((state) => state.userAuthReducer);
  const token = localStorage.getItem("token");

  // If user is authenticated, redirect based on their role
  if (token && role) {
    // Redirect all authenticated users to /immobilier
    return <Navigate to="/immobilier" replace />;
  }

  // If not authenticated, show the requested public route (like login page)
  return children;
};

export default PublicRoute;
